import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICreateResourceLinkMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  kindId: Types.Scalars['String']['input']
  sourceId: Types.Scalars['ObjectId']['input']
  targetId: Types.Scalars['ObjectId']['input']
}>

export type ICreateResourceLinkMutation = {
  createResourceLink?: {
    success: boolean
    sourceId?: any | null
    targetId?: any | null
    error?: string | null
  } | null
}

export type IDeleteResourceLinkMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  kindId: Types.Scalars['String']['input']
  sourceId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteResourceLinkMutation = {
  deleteResourceLink?: {
    success: boolean
    sourceId?: any | null
    targetId?: any | null
    error?: string | null
  } | null
}

export const CreateResourceLinkDocument = gql`
  mutation CreateResourceLink(
    $projectId: ObjectId!
    $kindId: String!
    $sourceId: ObjectId!
    $targetId: ObjectId!
  ) {
    createResourceLink(
      projectId: $projectId
      kindId: $kindId
      sourceId: $sourceId
      targetId: $targetId
    ) {
      success
      sourceId
      targetId
      error
    }
  }
`
export type ICreateResourceLinkMutationFn = Apollo.MutationFunction<
  ICreateResourceLinkMutation,
  ICreateResourceLinkMutationVariables
>

/**
 * __useCreateResourceLinkMutation__
 *
 * To run a mutation, you first call `useCreateResourceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceLinkMutation, { data, loading, error }] = useCreateResourceLinkMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      kindId: // value for 'kindId'
 *      sourceId: // value for 'sourceId'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCreateResourceLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateResourceLinkMutation,
    ICreateResourceLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateResourceLinkMutation,
    ICreateResourceLinkMutationVariables
  >(CreateResourceLinkDocument, options)
}
export type CreateResourceLinkMutationHookResult = ReturnType<
  typeof useCreateResourceLinkMutation
>
export type CreateResourceLinkMutationResult =
  Apollo.MutationResult<ICreateResourceLinkMutation>
export type CreateResourceLinkMutationOptions = Apollo.BaseMutationOptions<
  ICreateResourceLinkMutation,
  ICreateResourceLinkMutationVariables
>
export const DeleteResourceLinkDocument = gql`
  mutation DeleteResourceLink(
    $projectId: ObjectId!
    $kindId: String!
    $sourceId: ObjectId!
  ) {
    deleteResourceLink(
      projectId: $projectId
      kindId: $kindId
      sourceId: $sourceId
    ) {
      success
      sourceId
      targetId
      error
    }
  }
`
export type IDeleteResourceLinkMutationFn = Apollo.MutationFunction<
  IDeleteResourceLinkMutation,
  IDeleteResourceLinkMutationVariables
>

/**
 * __useDeleteResourceLinkMutation__
 *
 * To run a mutation, you first call `useDeleteResourceLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceLinkMutation, { data, loading, error }] = useDeleteResourceLinkMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      kindId: // value for 'kindId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useDeleteResourceLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteResourceLinkMutation,
    IDeleteResourceLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteResourceLinkMutation,
    IDeleteResourceLinkMutationVariables
  >(DeleteResourceLinkDocument, options)
}
export type DeleteResourceLinkMutationHookResult = ReturnType<
  typeof useDeleteResourceLinkMutation
>
export type DeleteResourceLinkMutationResult =
  Apollo.MutationResult<IDeleteResourceLinkMutation>
export type DeleteResourceLinkMutationOptions = Apollo.BaseMutationOptions<
  IDeleteResourceLinkMutation,
  IDeleteResourceLinkMutationVariables
>
